import { render } from "./PwTeamsOverview.vue?vue&type=template&id=caeab700"
import script from "./PwTeamsOverview.vue?vue&type=script&lang=js"
export * from "./PwTeamsOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__